<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid px-2">
    <div class="row">
      <div class="col px-0" id="tablecontainerrow">
        <div class="userscheduletable-container p-2" id="tablecontainer" style="width:100%;display:block">
          <table v-if="data != null" class="userscheduletable">
            <tr style="border-bottom:1px solid #ccc">
              <td v-for="item in data.weekdetail" class="listfont pb-1" style="width:111px;overflow:hidden;">
                <div v-show="item.previousWeekDate!=''">
                  <span v-show="item.previousWeekDate!=''" v-on:click="preNextGetSch(item.previousWeekDate)" class="btn p-0" style="float:left;top:0px;margin-left:0px;padding-left:0px;margin-right:5px"><</span>
                  <span style="margin:0px;float:left;" v-show="item.week!=''"><b>{{item.week}}</b></span>
                  <span v-show="item.nextWeekDate!=''" v-on:click="preNextGetSch(item.nextWeekDate)" class="btn p-0" style="float:left;top:0px;margin-left:5px;padding-left:0px;">></span>
                </div>
                <p v-show="item.displaydate!=''" class="px-2 mb-0 tabletitle">{{item.displaydate}}</p>
              </td>
            </tr>

            <tr v-for="locdetail in data.locationsdetail" style="border-top:1px solid #F6F7F7">
              <td v-show="locdetail.name!=''" class="py-3">
                {{locdetail.name}}
              </td>
              <td v-for="locdetail in locdetail.locationShifts" class="px-2 py-2" style="border-left: 1px solid #F6F7F7">
                <div>
                  <div @click="shiftClick(shift)" v-bind:class="[isExistId(shift.LocationShiftId,shift.Date) ? 'shift-highlight-container' : 'shift-default-container']" class="btn btn-schedule p-1" v-for="shift in locdetail.shifts" style="padding:0px !important;display:inline-table">
                    <div v-bind:class="[selectedlochiftId==shift.LocationShiftId ? 'shifticon hasshift scheduling-hasshift-' + shift.ShiftTypeId + ' shift-selected-border' : 'shifticon hasshift scheduling-hasshift-' + shift.ShiftTypeId]" v-show="isExistId(shift.LocationShiftId,shift.Date)" width="23" height="34" style="position:relative">
                      <!--<i class="icon-checkmark2" style="position:absolute;bottom:0;color:green;top:24px;right:4px;height:14px;font-size:13px;width:15px;"></i>-->
                    </div>
                    <div v-bind:class="[selectedlochiftId==shift.LocationShiftId ? 'shifticon noshift scheduling-noshift-' + shift.ShiftTypeId + ' shift-selected-border' : 'shifticon noshift scheduling-noshift-' + shift.ShiftTypeId]" v-show="!(isExistId(shift.LocationShiftId,shift.Date))" width="23" height="34" style="position:relative">
                      <!--<span class="empty-checkmark" style="position:absolute;bottom:0;color:green;top:24px;right:4px;height:14px;font-size:13px;width:15px;"></span>-->
                    </div>
                  </div>
                </div>
              </td>
            </tr>

          </table>
        </div>

      </div>

    </div>

    <div class="row" style="margin-top:50px;">
      <div class="col-12 pb-2">
        {{$t('export_import')}}
      </div>
    </div>
    <ul class="nav nav-tabs  nav-tabs-highlight skin light-bg mb-0" id="locshiftTabs">
      <li class="nav-item" style="border-left-width:0px !important">
        <a href="#locshiftexport" class="nav-link active show" data-toggle="tab">
          <i class="icon-file-download"></i>{{$t('export')}}
        </a>
      </li>
      <li class="nav-item">
        <a href="#locshiftimport" class="nav-link" data-toggle="tab">
          <i class="icon-file-upload"></i> {{$t('import')}}
        </a>
      </li>
    </ul>
    <div class="container-fluid">
      <div class="row">
        <div class="col p-2">
          <div class="tab-content border-top-0 rounded-top-0 mb-0">
            <div id="locshiftexport" class="tab-pane show active">
              <div class="row mt-3">
                <div class="text-right col-sm-12">
                  <button type="submit" class="btn skin primary-button" @click="exportLocsShifts">{{$t('export_procedure')}}</button>
                </div>
              </div>
            </div>
            <div id="locshiftimport" class="tab-pane bg-white">
              <div class="row mt-3">
                <div class="col-6">
                  <input type="file" @change="selectFile" class="h-auto" accept=".xlsx" />
                </div>
                <div class="col-6" style="text-align:right">
                  <button class="btn skin primary-button" v-on:click="importLocsShifts">{{$t('import_procedure')}}</button>
                </div>
                <div class="col-12">
                  <div v-if="msg != null && msg != ''" :class="messageClass" class="col-12 shadow-0 border-0 upload-error-message mt-3" role="alert">
                    <span v-html="msg"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
  import LocationSelector from '../location/location-selector.vue'
  import FullCalander from '../calander/full-calander.vue'
  var sdate = '';
  var edate = '';
  var locationshiftId = [];
  var user = '';
  export default {
    name: "user-schedule",
    components: {
      LocationSelector,
      FullCalander,
    },
    props: {
      onrefreshuserlist: {
        required: false,
        type: String,
        default: ''
      },
      onmanageuserscheduleclick: {
        required: false,
        type: String,
        default: ''
      },
    },
    data() {
      return {
        locationId: -1,
        data: null,
        locationshiftId: [],
        sdate: '',
        edate: '',
        selectedFiles: undefined,
        msg: '',
        messageClass: 'alert alert-success',
        user: '',
        selectedlochiftId: -1,
      };
    },
    methods: {
      isExistId(id, date) {
        var val = id + ',' + date;
        var index = this.locationshiftId.indexOf(val);
        if (index > -1) {
          return true;
        }
        return false;
      },
      selectFile(event) {
        this.msg = '';
        this.messageClass = 'alert alert-success';
        this.selectedFiles = event.target.files;
      },
      importLocsShifts() {
        if (this.selectedFiles == null || this.selectedFiles.length == 0)
          return;
        try {
          // try to log $refs object for deep understanding
          let fileToUpload = this.selectedFiles[0];
          let formData = new FormData();
          formData.append('fileToUpload', fileToUpload);
          var apiresponse = this.$http.post(
            '/api/Admin/v1/Upload/Location/Excel',
            formData
          ).then(response => {
            console.log(response.data);
            var data = response.data;
            if (data !== null && data.length > 0) {
              this.messageClass = 'alert alert-danger';
              data.forEach((msg, index) => {
                this.msg = this.msg + msg + "<br/>";
              });
            } else {
              this.msg = 'File imported successfully';
              this.getCalanderLocationShifts(this.sdate);
            }
            this.$forceUpdate();
          });

        } catch (err) {
          //alert(err);
        }
      },
      exportLocsShifts() {
        try {
          var date = moment().format('YYYY-MM-DD');
          var startDate = getMomentLocale(date).startOf('week').format('YYYY-MM-DD');
          var url = apiUrl + '/api/Admin/v1/Download/Location/Shift?date=' + this.sdate + '&siteId=' + this.$store.getSiteId();
          window.location = url;
          //this.$http.get(url).then(async response => {
          //  //Vue.set(this, "procedure", response.data)
          //  //this.$store.commit('loadnewProcedure', response.data)
          //});
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      shiftClick(shift) {
        //var locationDetail = this.data.locationsdetail;
        //locationDetail.forEach((innerdetail, index) => {
        //  if (innerdetail.locationShifts != undefined) {
        //    innerdetail.locationShifts.forEach((shiftdetail, index) => {
        //      if (shiftdetail.shifts != undefined) {
        //        shiftdetail.shifts.forEach((inner, index) => {
        //          if (inner.Users.length > 0) {
        //            inner.Users = [];
        //          }
        //          //inner.Users = [];
        //        });
        //      }
        //    });
        //  }
        //});
        var ids = [];
        var val = shift.LocationShiftId + ',' + shift.Date;
        if (this.user !== '') { // if all user select/unselect will not work
          this.addInLocationShiftIdArray(val);
          ids = this.locationshiftId;
        } else {
          ids.push(val);
          this.selectedlochiftId = shift.LocationShiftId;
        }
        this.manageUserSchedule(ids);
      },
      addInLocationShiftIdArray(val) {
        var index = this.locationshiftId.indexOf(val);
        if (index > -1) {
          this.locationshiftId.splice(index, 1);
        } else {
          this.locationshiftId.push(val);
        }
        return index > -1;
      },
      manageUserSchedule(locationShiftIds) {
        var viewtype = this.user !== '' ? 'adduserschedule' : 'viewuserschedule';
        var obj = {
          locationshiftid: locationShiftIds, viewtype: viewtype, tab: "UserScheduleAdmin",
          action: "manageuserschedule", sdate: this.sdate, edate: this.edate
        };
        var data = JSON.stringify(obj);
        //alert("onmanageuserscheduleclick from component:" + this.onmanageuserscheduleclick)
        if (this.onmanageuserscheduleclick != null) {
          eval(this.onmanageuserscheduleclick + "(obj)")
        }

        //vm.$root.$emit('refreshview', data);
      },
      cancelUserSchedule() {
        this.locationshiftId = [];

        var locationDetail = this.data.locationsdetail;
        locationDetail.forEach((innerdetail, index) => {
          if (innerdetail.locationShifts != undefined) {
            innerdetail.locationShifts.forEach((shiftdetail, index) => {
              if (shiftdetail.shifts != undefined) {
                shiftdetail.shifts.forEach((inner, index) => {
                  if (inner.Users.length > 0) {
                    var val = inner.LocationShiftId + ',' + inner.Date;
                    this.addInLocationShiftIdArray(val);
                  }
                });
              }
            });
          }
        });


        this.$forceUpdate();
      },
      clearSelection() {
        this.selectedlochiftId = -1;
      },
      refreshUserList() {
        var obj = {
          viewtype: 'adduserschedule', tab: "UserScheduleAdmin",
          action: "clearuserslist"
        };
        var data = JSON.stringify(obj);
        //alert("onrefreshUserList from component:" + this.onrefreshuserlist)
        if (this.onrefreshuserlist != null) {
          eval(this.onrefreshuserlist + "(obj)")
        }
        //vm.$root.$emit('refreshview', data);
      },

      viewSchedule(user, subaction) {
        if (subaction == 'getschedule') {
          this.getUserSchedule(this.sdate, this.edate, user);
        } //else if (subaction == 'hideschedule') {
        //  var locationDetail = this.data.locationsdetail;

        //  var arrayUsers = user.split(',');
        //  arrayUsers.forEach((value, i) => {
        //    locationDetail.forEach((innerdetail, index) => {
        //      if (innerdetail.locationShifts != undefined) {
        //        innerdetail.locationShifts.forEach((shiftdetail, index) => {
        //          if (shiftdetail.shifts != undefined) {
        //            shiftdetail.shifts.forEach((inner, index) => {
        //              var index = inner.Users.indexOf(value);
        //              if (index > -1) {
        //                inner.Users.splice(index, 1);
        //              }
        //            });
        //          }
        //        });
        //      }
        //    });
        //  });

        //  this.$forceUpdate();
        //}
      },
      getId() {
        return this._uid;
      },

      preNextGetSch(date) {
        this.selectedlochiftId = -1;
        this.refreshUserList();
        this.getCalanderLocationShifts(date);
      },



      getCalanderLocationShifts(date) {
        try {
          var tempDate = date;
          this.locationshiftId = [];
          date = date == '' ? moment().format('YYYY-MM-DD') : date;
          var startDate = getMomentLocale(date).startOf('week').format('YYYY-MM-DD');
          var endDate = getMomentLocale(date).endOf('week').format('YYYY-MM-DD');

          var firstDayOfWeek = getMomentLocaleData().firstDayOfWeek();
          var url = '/api/Admin/v1/Calander/LocationShift?date=' + startDate + '&dayOfWeek=' + firstDayOfWeek;
          this.$http.get(url).then(response => {
            this.data = { weekdetail: response.data[0].weekdetail, locationsdetail: response.data[0].locationsdetail };
            this.$forceUpdate();
            this.sdate = this.data.weekdetail[0].startDate;
            this.edate = this.data.weekdetail[0].endDate;

            //if (tempDate === '') {
            //var obj = {
            //  tab: "UserScheduleAdmin",
            //  action: "firstTimeLoad"
            //};
            //var data = JSON.stringify(obj);

            //  this.getUserSchedule(this.sdate, this.edate, this.user);

            //vm.$root.$emit('refreshview', data);
            //} else {
            //
            //}

            this.getUserSchedule(this.sdate, this.edate, this.user);
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      getUserSchedule(sdate, edate, user) {
        try {
          if (sdate === '' && edate === '') {
            return;
          }
          if (user !== '') {
            this.selectedlochiftId = -1;
          }
          this.user = user;
          //Users/Schedule/{startDate}/{endDate}/{user}
          //var url = '/api/AdminEntity/GetUserSchedule?startDate=' + sdate + '&endDate=' + edate + '&user=' + user;
          var url = '/api/Admin/v1/Users/Schedule/ByDate?startDate=' + sdate + '&endDate=' + edate + '&user=' + user;
          this.$http.get(url).then(response => {
            //this.data = { weekdetail: response.data[0].weekdetail, locationsdetail: response.data[0].locationsdetail };;
            this.locationshiftId = [];
            var result = response.data;
            var locationDetail = this.data.locationsdetail;

            locationDetail.forEach((innerdetail, index) => {
              if (innerdetail.locationShifts != undefined) {
                innerdetail.locationShifts.forEach((shiftdetail, index) => {
                  if (shiftdetail.shifts != undefined) {
                    shiftdetail.shifts.forEach((inner, index) => {
                      inner.Users = [];
                    });
                  }
                });
              }
            });



            result.forEach((detail, index) => {
              //var result = locationDetail. arr.find(x => x > 20);
              locationDetail.forEach((innerdetail, index) => {
                if (innerdetail.locationShifts != undefined) {
                  innerdetail.locationShifts.forEach((shiftdetail, index) => {
                    if (shiftdetail.shifts != undefined) {
                      shiftdetail.shifts.forEach((inner, index) => {
                        if (inner.Date == detail.date && inner.LocationShiftId == detail.locationshiftid) {
                          //var index = inner.Users.indexOf(detail.user);
                          //if (index === -1) {
                          //  inner.Users.push(detail.user);
                          //}
                          inner.Users.push(detail.user);

                          if (inner.Users.length > 0) {
                            var val = inner.LocationShiftId + ',' + inner.Date;
                            var index = this.locationshiftId.indexOf(val);
                            if (index === -1) {
                              this.locationshiftId.push(val);
                            }
                          }
                        }
                      });
                    }
                  });
                }
              });
            });
            console.log(locationDetail);
            this.$forceUpdate();
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
    },
    watch: {
    },
    mounted() {
      //this.$refs.locationselector.displayAddButton = false;
      //this.getCalanderLocationShifts('');
      //$("#select_assigned_shift_" + this.getId()).change(this.onChange);
    }
  };
</script>

<style scoped>

  .shifticon {
    width: 26px;
    height: 34px;
    background-repeat: no-repeat;
    background-position: 0px 0px;
    background-size: contain;
  }

    .shifticon.hasshift {
      background-color: #ccc;
    }



    .shifticon.noshift {
      background-color: white;
    }

  .scheduling-hasshift-1 {
    /*background-image: url("/Images/shifttypes/icon_1_inverted.png");*/
    background-image: url("/Images/shifttypes/icon_1.png");
  }

  .scheduling-hasshift-2 {
    /* background-image: url("/Images/shifttypes/icon_2_inverted.png");*/
    background-image: url("/Images/shifttypes/icon_2.png");
  }

  .scheduling-hasshift-3 {
    /* background-image: url("/Images/shifttypes/icon_3_inverted.png");*/
    background-image: url("/Images/shifttypes/icon_3.png");
  }

  .scheduling-noshift-1 {
    background-image: url("/Images/shifttypes/icon_1.png");
  }

  .scheduling-noshift-2 {
    background-image: url("/Images/shifttypes/icon_2.png");
  }

  .scheduling-noshift-3 {
    background-image: url("/Images/shifttypes/icon_3.png");
  }

  .userscheduletable-container {
    padding: 10px;
    overflow: visible;
    margin: auto;
    display: inline-table;
  }

    .userscheduletable-container table tr {
      /*color:black !important;*/
    }

  #userscheduletable {
    width: 100%;
  }
  .userscheduletable {
    width: 100%;
    min-width: 900px;
    display: inline-table;
  }

  @media (max-width: 768px) {
    #tablecontainer {
      overflow-x: scroll;
      max-width: 650px;
      display: inline-table;
    }

    .userscheduletable {
      width: calc(-70px + 100vw);
      overflow: auto;
      display: block;
    }

    #tablecontainerrow {
      width: 200px;
      overflow: auto;
      margin: auto;
    }
  }

  .tab-content > .active {
    display: block !important;
  }


  .tabletitle {
    max-width: 60px;
  }

  .select_container {
    width: calc(100%)
  }

  .listfont {
    font-size: 14px;
  }

  .shift-highlight-container {
  }

  .shift-selected-border {
    border: 2px solid #193e53;
  }

  .shift-default-container {
    border: 2px solid Green;
  }
</style>

<style>
  #userSchManageTab {
    /*padding-left: 150px;*/
  }

  @media (max-width: 768px) {
    #userSchManageTab {
      padding-left: inherit;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/scheduling/user-schedule.vue